import { Component, Signal, computed, input } from '@angular/core';
import { Observable, filter, map, of } from 'rxjs';
import {
  BOFeature,
  BOProduct,
  CmsComponentData,
  CMSTabParagraphContainer,
} from '@boels/models';
import { TranslocoModule } from '@jsverse/transloco';
import { ProductKeyFeaturesComponent } from './product-key-features/product-key-features.component';
import { ProductSymbolsComponent } from './product-symbols/product-symbols.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AsyncPipe, NgClass } from '@angular/common';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ProductPriceDisclaimerComponent } from '../product-price-disclaimer/product-price-disclaimer.component';
import { VerticalAlignerComponent } from '../vertical-aligner/vertical-aligner.component';

export interface ComponentDataWithProduct
  extends CmsComponentData<CMSTabParagraphContainer> {
  product$: Observable<BOProduct>;
}

@Component({
  selector: 'boels-product-attributes',
  templateUrl: './product-attributes.component.html',
  styleUrls: ['./product-attributes.component.scss'],
  imports: [
    AsyncPipe,
    NgClass,
    TranslocoModule,
    FontAwesomeModule,
    ProductKeyFeaturesComponent,
    ProductSymbolsComponent,
    ProductPriceDisclaimerComponent,
    VerticalAlignerComponent,
  ],
})
export class ProductAttributesComponent {
  readonly iconAttributeCode = 'IconAttributes';
  componentData = input.required<ComponentDataWithProduct>();
  features: Signal<Observable<BOFeature[]>> = computed(() => {
    const product = this.componentData()?.product$;
    if (!product) return of([]);
    return product.pipe(
      map((product: BOProduct) => product.classifications),
      filter(Boolean),
      map((classifications) =>
        classifications
          .filter((classItem) => classItem.code !== this.iconAttributeCode)
          .map((classItem) => classItem.features || [])
          .flat(),
      ),
    );
  });
  faCheck = faCheck;
  faTimes = faTimes;

  getDisplayValueUnit(unitSymbol?: string): string {
    if (!unitSymbol) return '';
    return `(${unitSymbol})`;
  }

  getIconTranslationTitleKey(featureValue: string): string {
    return `productDetails.productAttributesTab.${
      featureValue === 'true' ? 'yes' : 'no'
    }`;
  }
}
